"use client";

import React from "react";
import { Shield, Heart, CircleCheck, Award } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const ingredients = [{
  title: "Unwavering Security",
  description: "Our policies are backed by top-tier global reinsurers, ensuring your family's future remains protected under any circumstance.",
  icon: Shield
}, {
  title: "Compassionate Care",
  description: "We treat every client like family, providing personalized guidance that prioritizes your unique legacy and peace of mind.",
  icon: Heart
}, {
  title: "Guaranteed Payouts",
  description: "With a 99% claims acceptance rate, we pride ourselves on a transparent process that delivers when it matters most.",
  icon: CircleCheck
}, {
  title: "Certified Expertise",
  description: "Our agents are nationally recognized for excellence in financial planning and ethical insurance practices.",
  icon: Award
}];
export default function WhyFamiliesTrustUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223996" id="why-families-trust-us" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20 lg:mb-24">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6 text-foreground">
            Why Families Trust Us
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl leading-relaxed font-default">
            LIFECOVER combines modern efficiency with a heritage of trust to provide the most reliable life insurance solutions available today.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 lg:gap-12">
          {ingredients.map((item, i) => <div key={i} data-index={i} className={`flex flex-col items-center text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <div className="mb-8 p-5 rounded-lg bg-accent text-primary shadow-sm">
                <item.icon className="size-8 stroke-[1.5]" />
              </div>
              <h3 className="font-default text-xl font-semibold mb-4 text-foreground">
                {item.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed font-default">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}